import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as dynamicAgentGroupService from "../../../services/smartConnect/dynamicAgentGroup.js";

export const createDynamicAgentGroupDispatcher = createAsyncThunk(
  "dynamicAgentGroup/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await dynamicAgentGroupService.createDynamicAgentGroupService(
        payload,
      );

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Failed to create dynamic Agent Group",
        );
      }

      return res?.message || "Dynamic Agent Group Successfully Created.";
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        "Internal Server Issue while creating dynamic agent group",
      );
    }
  },
);

export const fetchAllDynamicAgentGroups = createAsyncThunk(
  "dynamicAgentGroup/fetchAll",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await dynamicAgentGroupService.fetchDynamicAgentGroupsService(
        payload,
      );

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Failed to fetch dynamic Agent Groups",
        );
      }

      return res?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        "Internal Server Issue while fetching dynamic agent groups",
      );
    }
  },
);

export const fetchDynamicGroupAgentList = createAsyncThunk(
  "dynamicAgentGroup/fetchDynamicAgentGroupList",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await dynamicAgentGroupService.fetchDynamicAgentGroupList(
        payload,
      );

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Failed to fetch dynamic Agent Groups List",
        );
      }

      return res?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        "Internal Server Issue while fetching dynamic agent group List",
      );
    }
  },
);

export const saveAgentsInGroupDispatcher = createAsyncThunk(
  "dynamicAgentGroup/addNewAgents",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await dynamicAgentGroupService.addNewAgentsInDynamicGroup(
        payload,
      );

      if (!res?.success) {
        return rejectWithValue(
          res?.message ||
          "Failed to add new agents in this group. please try again later",
        );
      }

      return res?.message || "Agents successfully save";
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        "Internal Server Issue while updating dynamic agent group List",
      );
    }
  },
);

export const fetchDynamicGroupAllAgents = createAsyncThunk(
  "dynamicAgentGroup/fetchDynamicGroupAllAgents",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await dynamicAgentGroupService.fetchDynamicAgentGroupList(
        payload,
      );

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Failed to fetch dynamic Agent Groups List",
        );
      }

      return res?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        "Internal Server Issue while fetching dynamic agent group List",
      );
    }
  },
);

export const updateDynamicGroupStatusDispatcher = createAsyncThunk(
  "dynamicAgentGroup/updateStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await dynamicAgentGroupService.updateAgentGroupStatus(
        payload,
      );

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Error while updating dynamic group agent status",
        );
      }

      return res?.message;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        "Internal Server Issue while updating dynamic agent group status",
      );
    }
  },
);


export const manualDidAssignInitiateThunk = createAsyncThunk(
  'dynamicAgentGroup/manualDidAssignInitiate',
  async (payload, thunkAPI) => {
    try {
      const result = await dynamicAgentGroupService.manualDidAssignInitiate(payload);
      if (!result.success) {
        return thunkAPI.rejectWithValue(result.message || "Something went wrong.");
      }
      return result?.message || "Your Request has been initiated. please wait";
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err?.response?.data?.message ||
        "Internal Server Issue while initiating request",
      );
    }
  }
)

const initialState = {
  dynamicAgentGroups: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  },
  agentList: {
    data: [],
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 0,
    },
    loading: false,
    error: null,
  },
  allAgents: {
    data: [],
    loading: false,
    error: null,
  },
  didAssignmentList: {
    filters: {},
    currentGroup: {},
  },
  loading: false,
  error: null,
};

const dynamicAgentGroupSlice = createSlice({
  name: "dynamicAgentGroup",
  initialState,
  reducers: {
    resetDynamicAgentGroupState: () => initialState,
    didAssignmentListStoreFiltersAndAgentGroup: (state, action) => {
      const { filters, currentGroup } = action.payload;
      // console.log("action : ", action);
      state.didAssignmentList.filters =
        filters || state.didAssignmentList.filters;
      state.didAssignmentList.currentGroup =
        currentGroup || state.didAssignmentList.currentGroup;
    },
  },
  extraReducers: (builder) => {
    builder
      // CREATE GROUP
      .addCase(createDynamicAgentGroupDispatcher.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDynamicAgentGroupDispatcher.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createDynamicAgentGroupDispatcher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

    // FETCH GROUP AGENTS (PAGINATED)
    builder
      .addCase(fetchAllDynamicAgentGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllDynamicAgentGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.dynamicAgentGroups = action.payload || [];
        state.pagination =
          action.payload?.pagination || initialState.pagination;
        state.error = null;
      })
      .addCase(fetchAllDynamicAgentGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

    // FETCH DYNAMIC GROUP AGENTS LIST(PAGINATED)
    builder
      .addCase(fetchDynamicGroupAgentList.pending, (state) => {
        state.agentList.loading = true;
        state.agentList.error = null;
      })
      .addCase(fetchDynamicGroupAgentList.fulfilled, (state, action) => {
        console.log("action : ", action.payload);
        state.agentList.loading = false;
        state.agentList.data = action.payload.list || [];
        state.agentList.pagination =
          action.payload?.pagination || initialState?.agentList.pagination;
        state.agentList.error = null;
      })
      .addCase(fetchDynamicGroupAgentList.rejected, (state, action) => {
        state.agentList.loading = false;
        state.agentList.error = action.payload || action.error.message;
      });

    // fetch all the agents from campaign db
    builder
      .addCase(fetchDynamicGroupAllAgents.pending, (state) => {
        state.allAgents.loading = true;
        state.allAgents.error = null;
      })
      .addCase(fetchDynamicGroupAllAgents.fulfilled, (state, action) => {
        state.allAgents.loading = false;
        state.allAgents.data = action.payload.list || [];
        state.allAgents.error = null;
      })
      .addCase(fetchDynamicGroupAllAgents.rejected, (state, action) => {
        state.allAgents.loading = false;
        state.allAgents.error = action.payload || action.error.message;
      });
  },
});

export const {
  resetDynamicAgentGroupState,
  didAssignmentListStoreFiltersAndAgentGroup,
} = dynamicAgentGroupSlice.actions;

export const dynamicAgentGroupReducer = dynamicAgentGroupSlice.reducer;
